import React, {useEffect, useRef, useState} from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorMessages, SuccessMessages } from "../../../app/Messages";
import {useGetWorkflowsFromOrganizationQuery, useGetWorkplacesFromOrganizationQuery} from "../../../app/services/organization";
import List from "../../../components/list/List";
import ListOverviewTemplate from "../../../layouts/ListOverviewTemplate";

import {
	useCreateWorkplaceMutation,
	useGetWorkplaceQuery,
	useUpdateWorkplaceMutation,
} from "../../../app/services/workplace";
import { getCurrentOrganization } from "../../../app/slices/appStateSlice";
import {
	NotificationType,
	startNotification,
} from "../../../app/slices/notifactionStateSlice";
import Details from "../../../layouts/Details";
import { ModalTypes } from "../../../modules/Modals/ConfirmDeleteModal";
import ErrorHandler from "../../../app/ErrorHandler";
import SmallSpinner from "../../../modules/spinner/SmallSpinner";
import {useCreateRAGDocumentMutation, useGetRAGDocumentUploadConfigQuery, useGetWorkplaceRAGDocumentsQuery, useIngestRAGDocumentMutation, useUpdateRAGDocumentMutation} from "../../../app/services/llm";

const WorkplaceDetail = ({ data }) => {
	const rootPath = "/workplaces";

	const [updateWorkplace] = useUpdateWorkplaceMutation();
	const [createWorkplace] = useCreateWorkplaceMutation();

	const currentOrg = useSelector(getCurrentOrganization);
	const editMode = Object.keys(data).length !== 0;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { refetch } = useGetWorkplaceQuery(data.id);
	const { refetch: refetchWorkplaces } =
		useGetWorkplacesFromOrganizationQuery(currentOrg.id);
	const [items, setItems] = useState([]);
	const [workflowGroups, setWorkflowGroups] = useState([]);

	const [documents, setDocuments] = useState([]);

	const {
		data: documentData,
		error: errorLoadingDocuments,
		isLoading: isLoadingDocuments
	} = useGetWorkplaceRAGDocumentsQuery(data.id);
	const documentFileUploadInput = useRef(null);

	useEffect(() => {
		setDocuments(documentData);
		console.log(documentData);
	}, [documentData]);

	const [newDocuments, setNewDocuments] = useState([]);

	const [skip, setSkip] = useState(true);
	const {
		data: workflowData,
		isLoading,
		error,
		isSuccess: loadSuccess,
	} = useGetWorkflowsFromOrganizationQuery(currentOrg && currentOrg.id, {
		skip,
	});
	useEffect(() => {
		currentOrg && setSkip(false);
	}, [currentOrg]);

	useEffect(() => {
		loadSuccess && setItems(workflowData);
		if(data.id && workflowData) {
			let workflowGroupDataReduced = workflowData
				.filter(wf => wf.workplace?._id === data.id)
				.reduce((acc, curr, index) => {
				if(acc[curr.workplace?._id]) {
					acc[curr.workplace?._id].push(curr);
				} else {
					acc[curr.workplace?._id] = [curr];
				}
				return acc;
			}, {});
			workflowGroupDataReduced = Object.values(workflowGroupDataReduced);
			setWorkflowGroups(workflowGroupDataReduced)
		}

		!isLoading && error && ErrorHandler(error);
	}, [error, isLoading, loadSuccess, workflowData]);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	useEffect(() => {}, [currentOrg]);

	const handleSave = (formData) => {
		// var formData = new FormData(document.querySelector("form"));
		// var postData = Object.fromEntries(formData.entries());
		var postData = formData;
		postData = { ...postData, organization: currentOrg.id };

		try {
			editMode
				? updateWorkplace({ id: data.id, patch: postData }).then(() => {
						dispatch(
							startNotification({
								message: SuccessMessages.SAVE,
								type: NotificationType.SUCCESS,
							})
						);
						refetch();
				  })
				: createWorkplace(postData).then(() => {
						startNotification({
							message: SuccessMessages.CREATE,
							type: NotificationType.SUCCESS,
						});
						refetchWorkplaces();
						navigate(-1);
				  });
		} catch (error) {
			dispatch(
				startNotification({
					message: error.message
						? error.message
						: "An error occured.",
					type: NotificationType.ERROR,
				})
			);
		}
	};

	const handleView = (item) => {
		navigate("/workflows/" + item.id);
	};

	const handleRowClick = (e, item) => {
		if (e.target.type === "button" || e.target.type === "submit") return;
		handleView(item);
	};

	const ListGroup = ({workflows}) => {
		let workplaceName = workflows[0].workplace.name;
		let workplaceId = workflows[0].workplace.id;
		return(
			<div className={"drop-container"} key={workplaceId}>
				<div className={"workplace-title"}>
					Workflows
				</div>
				{workflows.map((item, index) => (
					<ListItem index={index} item={item} key={"workplace-view-"+item.id}/>
				))}
			</div>
		)
	}

	const ListItem = ({ item, index }) => {
		return (
			<List.Item
				onClick={(e) => handleRowClick(e, item)}
				classes={"clickable"}
				key={item.id}
				buttons={[]}
			>
				<List.Item.Content key="index">{index + 1}</List.Item.Content>
				<List.Item.Content title key="name">
					{item.name}
				</List.Item.Content>
			</List.Item>
		);
	};

	const uploadDocument = () => {
		if(documentFileUploadInput.current) {
			documentFileUploadInput.current.click();
		}
	}

	const onDocumentChange = async (event) => {
		let filename = event.target.files[0].name;
		let file = await event.target.files[0].arrayBuffer();
		setNewDocuments([...newDocuments, {filename, file}]);
		console.log("EVENT", event.target.files)
	}

	const DocumentListGroup = ({documents, workplaceId}) => {
		return(
			<div className={"drop-container"}>
				<div className={"workplace-title"}>
					AI Documents
				</div>
				{documents.map((item, index) => (
					<DocumentListItem index={index} item={item} key={"workplace-view-"+item.id}/>
				))}
				{newDocuments.map((item, index) => (
					<NewDocumentListItem index={index}
										 filename={item.filename}
										 file={item.file}
										 workplaceId={workplaceId}
										 key={"workplace-view-"+item}
					/>
				))}
			</div>
		)
	}

	const DocumentListItem = ({item}) => {
		return (
			<List.Item
				classes={"clickable"}
				buttons={[]}
			>
				<List.Item.Content key="index"></List.Item.Content>
				<List.Item.Content title key="name">
					{item.name}
				</List.Item.Content>
			</List.Item>
		);
	}

	const NewDocumentListItem = ({filename, file, workplaceId}) => {
		const [uploadActive, setUploadActive] = useState(true);
		const [uploadMessage, setUploadMessage] = useState("");

		//first we create
		const [createRAGDocument, {data: createdRAGDocument}] = useCreateRAGDocumentMutation();
		const [documentId, setDocumentId] = useState("");
		const {data: uploadSlotConfig} = useGetRAGDocumentUploadConfigQuery({
				workplaceId,
				documentId
			},
			{
				skip: documentId === ""
			}
		);
		useEffect(() => {
			console.log("document created", JSON.stringify(createdRAGDocument));
			setUploadMessage("Triggering document Upload...");
			let createdDocumentId = createdRAGDocument?.id;
			if(createdDocumentId) {
				console.log("document created", JSON.stringify(createdRAGDocument?.id));
				setDocumentId(createdRAGDocument.id);
			}
		}, [createdRAGDocument]);

		//after these hooks we have an upload url and can actually perform the upload to s3

		useEffect(() => {
			setUploadMessage("Uploading Document ...");
			if(uploadSlotConfig?.url && workplaceId && documentId) {
				fetch(uploadSlotConfig?.url, {
					method: "PUT",
					headers: {
						"x-amz-server-side-encryption": "aws:kms",
					},
					body: file,
					//TODO: error handling
				}).then(res => {
					setUploadMessage("Document upload complete ...");
					updateRAGDocument({
						workplaceId,
						documentId,
						fileId: uploadSlotConfig?.uploadObjectId
					})
				});
			}
		}, [uploadSlotConfig, workplaceId, documentId])

		//after the upload, we reconfigure the RAG document to the new uploaded document
		const [updateRAGDocument, {data: RAGDocumentConfig}] = useUpdateRAGDocumentMutation();

		useEffect(() => {
			setUploadMessage("Starting document processing/ingest ...");
			if(RAGDocumentConfig?.id) {
				ingestRAGDocument({
					workplaceId,
					documentId
				});
			}
		}, [RAGDocumentConfig, workplaceId, documentId]);
		//after reconfiguring the upload, now it is time to ingest the document
		const [ingestRAGDocument, {data: RAGDocumentIngestResult}] = useIngestRAGDocumentMutation();
		useEffect(() => {
			if(RAGDocumentIngestResult?.ingested) {
				setUploadMessage("Done processing document.");
				setUploadActive(false);
			}
		}, [RAGDocumentIngestResult]);

		const [startUpload, setStartUpload] = useState(true);
		useEffect(() => {
			if(startUpload) {
				setStartUpload(false);
				console.log("trigger document creation");
				setUploadMessage("Triggering document Creation...");
				createRAGDocument({
					workplaceId,
					name: filename
				});
			}
		}, [startUpload]);
		return (
			<List.Item
				classes={"clickable"}
				buttons={[]}
			>
				<List.Item.Content key="index"></List.Item.Content>
				<List.Item.Content title key="name">
					{filename}
					{documentId}
					{uploadActive && (<SmallSpinner/>)}
					{uploadMessage}
				</List.Item.Content>
			</List.Item>
		);
	}


	return (
		<>
			{currentOrg && (
				<form>
					<Details
						saveFunction={handleSubmit(handleSave)}
						modalData={{
							type: ModalTypes.Workplace,
							data: data,
							navigate: rootPath,
						}}
					>
						<div className="form-group">
							<div className="form-group">
								<div className={`label-container`}>
									<label htmlFor={"name"}>
										Workplace Name
									</label>
								</div>
								<div
									className={`input-container ${
										errors["name"] && "error"
									}`}
								>
									<input
										name={"name"}
										type={"text"}
										placeholder="Workplace Name"
										className={`form-control mr-2 centered ${
											errors["name"] && "error"
										}`}
										defaultValue={data?.name ?? ""}
										{...register("name", {
											required: ErrorMessages.REQUIRED,
										})}
									/>
									{errors && errors["name"] && (
										<span className="error">
											{errors["name"]?.message}
										</span>
									)}
								</div>
							</div>
						</div>
					</Details>
				</form>
			)}
      {data.id ? (
        <>
          <ListOverviewTemplate
            addCallback={uploadDocument}
            isLoading={isLoading}
            addButtonText={"Upload Document"}
          >
            {documents && (
              <List id="documents">
                {
                  <DocumentListGroup documents={documents}
                                     workplaceId={data.id}/>
                }
              </List>
            )}
            <input type='file' id='workplace-document-file-upload' onChange={onDocumentChange} ref={documentFileUploadInput} style={{display: 'none'}} accept="application/pdf,.pdf"/>
          </ListOverviewTemplate>
          <ListOverviewTemplate isLoading={isLoading}>
            {items && items.length > 0 ? (
              <List id="workflows">
                {
                  workflowGroups.map(workflowGroup => (
                    <ListGroup workflows={workflowGroup} key={"workplace-group-"+workflowGroup[0].workplace.id}/>
                  ))
                }
              </List>
            ) : (
              <p>No workflows found.</p>
            )}
          </ListOverviewTemplate>
        </>
        ) : (<></>)}
		</>
	);
};

export default WorkplaceDetail;
